const B4_STATIC = "/static/images";

/** Caminho público para arquivo em public/static/images (ex.: Mini Certificado PT.png). */
export function b4PublicImage(filename) {
  return `${B4_STATIC}/${encodeURIComponent(filename)}`;
}

/** Ativos B4 / Vert (PT + EN) — exclui blue-black-minimalist-logo. */
export const B4_IMG = {
  seloPT: b4PublicImage("Selo PT.png"),
  seloEN: b4PublicImage("Selo EN.png"),
  miniCertPT: b4PublicImage("Mini Certificado PT.png"),
  miniCertEN: b4PublicImage("Mini Certificado EN.png"),
  certPT: b4PublicImage("Certificado PT.png"),
  certEN: b4PublicImage("Certificado EN.png"),
  qrPT: b4PublicImage("Certificado QRCODE PT.png"),
  qrEN: b4PublicImage("Certificado - QRCODE EN.png"),
};

/** Seleciona asset PT ou EN conforme idioma (`pt` | `en`). */
export function b4ImageForLang(language, kind) {
  const en = language === "en";
  let path;
  switch (kind) {
    case "selo":
      path = en ? B4_IMG.seloEN : B4_IMG.seloPT;
      break;
    case "miniCert":
      path = en ? B4_IMG.miniCertEN : B4_IMG.miniCertPT;
      break;
    case "cert":
      path = en ? B4_IMG.certEN : B4_IMG.certPT;
      break;
    case "qr":
      path = en ? B4_IMG.qrEN : B4_IMG.qrPT;
      break;
    default:
      path = B4_IMG.seloPT;
  }
  /* Força novo fetch ao trocar idioma (evita cache agressivo exibindo PNG errado). */
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}lang=${en ? "en" : "pt"}`;
}
